import { Cart } from '@miles/domain/Store/Models/Cart/Cart'
import {
  BibLineItem,
  LineItem,
  OrderLineItem
} from '@miles/domain/Store/Models/LineItem/LineItem'
import { LineItemService } from '@miles/domain/Store/Services/LineItem/LineItemService'
import { Number } from 'effect'
import { match, P } from 'ts-pattern'
import { VariantId } from 'domain/models/ValueObject/EntityIds'

export const CartUtils = {
  getItemSubTotal: (item: OrderLineItem): number => item.subtotal,
  getDiscountedItemPrice: (item: OrderLineItem): number => item.total,
  getAdjustedItemPriceExceptedPromotionForCart: (item: LineItem): number => {
    return (
      LineItemService.getTotalInclusiveOfInsurance(item) +
      match(item)
        .with({ adjustments: P.nonNullable }, ({ adjustments }) => {
          return Number.sumAll(
            adjustments
              .filter((r) => r.type === 'PromoCode')
              .map((r) => r.amount)
          )
        })
        .otherwise(() => 0)
    )
  },
  getReducedItemPrice: (item: LineItem): number => {
    return (
      item.subtotal -
      match(item)
        .with({ adjustments: P.nonNullable }, ({ adjustments }) => {
          return Number.sumAll(
            adjustments
              .filter((r) => r.type === 'Reduction')
              .map((r) => r.amount)
          )
        })
        .otherwise(() => 0)
    )
  },
  getOptionsPriceForItem: (item: LineItem): number => {
    return match(item)
      .with({ insurance: P.nonNullable }, ({ insurance }) => {
        return insurance.amount
      })
      .otherwise(() => 0)
  },
  isCartItemVariantSameAsRaceVariantId:
    (variantId: VariantId) =>
    (
      item: LineItem
    ): item is BibLineItem & {
      variant: NonNullable<LineItem['variant']>
    } =>
      item.variant !== null && item.variant.id === variantId,
  isBib: (item: OrderLineItem) =>
    item.type === 'SoloBib' || item.type === 'TeamBib',
  getDiscount: (cart: Cart) =>
    cart.discounts.find(({ metadata }) => !metadata?.type)
}
